
import { EVENTS } from '../../../../shared/Events';

class SwitchAngel extends PIXI.Container {
  constructor() {
    super();

    // const
    this.ARROW = {
      HIDDEN: {
        X: 42,
        Y: -5,
      },
      OVER: {
        X: 49,
        Y: -28,
      },
      OUT: {
        X: 52,
        Y: -53,
      },
    };
    this.POSITION = {
      X: 654,
      Y: 86,
    };
    this.DIFFERENCE = {
      X: 2,
      Y: 1,
    };

    // parts
    this.angel = null;
    this.angelHover = null;
    this.arrow = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // parts
    this.angel = new PIXI.Sprite.fromFrame('andel-0.png');
    this.addChild(this.angel);

    this.angelHover = new PIXI.Sprite.fromFrame('andel-1.png');
    this.angelHover.visible = false;
    this.addChild(this.angelHover);

    this.arrow = new PIXI.Sprite.fromFrame('andel-arrow.png');
    this.arrow.alpha = 0;
    this.addChild(this.arrow);

    // interactivity
    this.hitArea = new PIXI.Rectangle(0, 0, 91, 87);
    this.interactive = true;
    this.buttonMode = true;
    this.on('pointerdown', () => {
      this.switchClick();
    });
    this.on('pointerover', () => {
      this.hoverAnim(true);
    });
    this.on('pointerout', () => {
      this.hoverAnim(false);
    });

    // loop
    aScene.signals.loopCall.add(this.loopUp, this);
  }

  switchClick() {
    if (aScene.sceneManager.sceneState === 0) {
      aScene.signals.sceneCallMain.dispatch(EVENTS.MOVE_TO_HEAVEN_START);
      aPage.stats.trackEvent('Andel-nahoru');
    }
  }

  // --------------------------------------------------------------
  // Hover
  // --------------------------------------------------------------

  hoverAnim(doHover) {
    TweenMax.killTweensOf(this.arrow);
    if (doHover) {
      this.angel.visible = false;
      this.angelHover.visible = true;
      this.arrow.x = this.ARROW.HIDDEN.X;
      this.arrow.y = this.ARROW.HIDDEN.Y;
      this.arrow.alpha = 0;
      TweenMax.to(this.arrow, 0.8, {
        x: this.ARROW.OVER.X,
        y: this.ARROW.OVER.Y,
        alpha: 1,
        ease: Back.easeOut,
      });
      aScene.sndManager.playItemSfx('andel');
    } else {
      this.angel.visible = true;
      this.angelHover.visible = false;
      TweenMax.to(this.arrow, 0.4, {
        x: this.ARROW.OUT.X,
        y: this.ARROW.OUT.Y,
        alpha: 0,
        ease: Sine.easeIn,
      });
    }
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    if (aScene.sceneManager.sceneState !== 1) {
      this.x = this.POSITION.X - (this.DIFFERENCE.X * aScene.iManager.stageRatio.half.x);
      this.y = this.POSITION.Y - (this.DIFFERENCE.Y * aScene.iManager.stageRatio.half.y);
    }
  }
}

export default SwitchAngel;



// WEBPACK FOOTER //
// ./src/js/scene/parts/town/parts/SwitchAngel.js